<vnm-validation-errors [errors]="errors"></vnm-validation-errors>
<div class="flex flex-column gap-md">
  <fieldset class="is-warning">
    <legend translate>user-update.platform-title</legend>
    <ng-container [ngSwitch]="formState">
      <ng-container *ngSwitchCase="'user'">
        <form [formGroup]="updateForm" (ngSubmit)="onUserUpdate()" class="flex-1">
          <vnm-form-actions direction="rtl" [showCancel]="false">
            <input
              pInputText
              type="text"
              formControlName="firstName"
              class="w-full"
              vnmPlaceholder="user-update.first-name-placeholder"
              [hidden]="!updateForm.get('firstName').enabled"
            />
            <input
              pInputText
              type="text"
              formControlName="lastName"
              class="w-full"
              vnmPlaceholder="user-update.last-name-placeholder"
              [hidden]="!updateForm.get('lastName').enabled"
            />
            <input
              pInputText
              type="email"
              formControlName="email"
              class="w-full"
              vnmPlaceholder="user-update.email-placeholder"
              [hidden]="!updateForm.get('email').enabled"
            />
          </vnm-form-actions>
        </form>
      </ng-container>
      <ng-container *ngSwitchCase="'certification'">
        <div class="flex flex-column gap-sm">
          <div class="flex gap-md align-items-center">
            <fa-icon icon="user-times" size="2x" [fixedWidth]="true"></fa-icon>
            <span>{{ certification.userFirstName }} {{ certification.userLastName }}</span>
            <button
              pButton
              type="button"
              [label]="'user-update.update-account' | translate"
              (click)="onCertificationUpdate()"
              class="p-button-secondary ml-auto"
              [disabled]="errors?.length"
            ></button>
          </div>
          <small class="platform-update" translate>user-update.platform-update</small>
        </div>
      </ng-container>
    </ng-container>
  </fieldset>
</div>
